import React from 'react'
import { BadgeStyles } from './Styled'

/**
 * Badge (MUI Badge wrapper)
 * Small count/status indicator. Used mainly in sidebar items to show a numeric badge.
 * Styling is driven by `active` — active state uses secondary/orange tones, inactive uses dark/white.
 *
 * Exported as `Badge` from `components/Form`. Internal name: `CustomBadge`.
 * Renders badge content only (no wrapped child element).
 *
 * @param {Object} props
 * @param {number|string} props.value - Content shown inside the badge (`badgeContent`).
 * @param {boolean} [props.active] - Active visual state. Affects text and background colors via `BadgeStyles`.
 * @example
 * <Badge active value={3} />
 * @example
 * // In SideBarItem — badge count from props
 * {!badge || <Badge active value={badge} />}
 */
const CustomBadge = (props) => {
    const { value, active } = props

    return (
        <BadgeStyles active={active} badgeContent={value} color="primary" />
    )
}

export default CustomBadge